import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=77827415"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports